
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { globalStatus }  from "../../../helpers/helper"
import DealerCreateModal from "./dealer_create_modal.vue"
import UserLogModal from "./user_log_modal.vue"
import abilityModal from "../dealer/abilities.vue";

export default {
  page: {
    title: "Kullanıcı Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DealerCreateModal,
    UserLogModal,
    abilityModal 
  },
  data() {
    return {
        list: {},
        title: "KULLANICI LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "KULLANICI LİSTESİ",
            active: true,
          },
        ],
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "users",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          label: 'Online',
          field: this.online,
          sortable: false,
        },
        {
          label: 'Kullanıcı Tipi',
          field: 'type_format',
          tdClass: this.thClassFunc,
        },
        {
          label: 'İsim Soyisim',
          field: 'name',
          tdClass: this.thClassFunc,
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
          tdClass: this.thClassFunc,
        },
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
          tdClass: this.thClassFunc,
        },
      ],
    };
  },
   mounted() {
    this.loadItems()
  },
  methods: {
     online(obj){
      return obj.tokens?.length > 0 ? obj.tokens.length + ' cihaz ile online' : 'Son deneme: ' + obj.user_auth_logs?.created_at
    },

    thClassFunc({type}) {
        
        let classStyle = ''
        switch (type) {
            case 'admin':
                classStyle = 'admin-class';
                break;
            case 'dealer':
                classStyle = 'dealer-class';
                break;
            case 'tech':
                classStyle = 'tech-class';
                break;
            case 'personel':
                classStyle = 'personel-class';
                break;
            case 'callcenter':
                classStyle = 'callcenter-class';
                break;
        }
        return classStyle
    },
    status(rowObj) {
      return globalStatus(rowObj.status);
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
    return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
    },
    create(){
       this.list = {}
       this.$parent.$bvModal.show('modal-scoped')
    },
    update(props){
       const { ablty, id, name, password, type, username, sub_type } = props
       this.list = {  ablty, id, name, password, type, username, sub_type  }
       this.$parent.$bvModal.show('modal-scoped')
    },
    log(props){
       this.list = props
       this.$parent.$bvModal.show('modal-log')
    }, 
    ability(props){
      this.list = props
      this.$parent.$bvModal.show('modal-ability')
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <dealer-create-modal :list="list" @loadItems="loadItems"/>
    <user-log-modal :list="list" />
    <ability-modal :list="list"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: true,
                    placeholder: 'Arama İçin Enter\'a Basınız'
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions">
                    <button 
                    class="btn btn-success btn-sm" 
                    style="margin-right:10px;margin-top:2px" 
                    type="button" 
                    @click="create()"
                    >Yeni Oluştur
                    </button>
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                     <ul class="list-inline font-size-20 contact-links mb-0">
                         <li class="list-inline-item">
                          <a @click="ability(props.row)">
                            <i class="mdi mdi-account-details-outline"></i>
                          </a>
                         </li> 
                        <li class="list-inline-item">
                          <a @click="update(props.row)">
                            <i class="mdi mdi-circle-edit-outline"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a @click="log(props.row)">
                            <i class="mdi mdi-shield-account-variant-outline"></i>
                          </a>
                        </li>
                      </ul>
                  </span>
                   <span
                    v-else-if="props.column.field === 'type_format'"
                    class="text-nowrap">
                        {{ props.row.id == 1 ? 'Süperadmin' : props.row.type_format }}
                  </span>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>